import { render, staticRenderFns } from "./QuoteEstImage.vue?vue&type=template&id=1dbf7318&scoped=true"
import script from "./QuoteEstImage.vue?vue&type=script&lang=js"
export * from "./QuoteEstImage.vue?vue&type=script&lang=js"
import style0 from "./QuoteEstImage.vue?vue&type=style&index=0&id=1dbf7318&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbf7318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dbf7318')) {
      api.createRecord('1dbf7318', component.options)
    } else {
      api.reload('1dbf7318', component.options)
    }
    module.hot.accept("./QuoteEstImage.vue?vue&type=template&id=1dbf7318&scoped=true", function () {
      api.rerender('1dbf7318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteEstImage.vue"
export default component.exports